import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  print() {
    const frame = document.createElement("iframe")
    const cleanup = () => frame.remove()

    frame.setAttribute("aria-hidden", "true")
    frame.style.position = "fixed"
    frame.style.width = "0"
    frame.style.height = "0"
    frame.style.border = "0"
    frame.style.visibility = "hidden"

    frame.addEventListener("load", () => {
      frame.contentWindow.addEventListener("afterprint", cleanup, { once: true })
      frame.contentWindow.focus()
      requestAnimationFrame(() => frame.contentWindow.print())
      window.setTimeout(cleanup, 60_000)
    }, { once: true })
    frame.addEventListener("error", cleanup, { once: true })
    frame.src = this.urlValue
    document.body.append(frame)
  }
}
